module.exports = "/_next/static/images/ActivateUnify@2x-e078713a428366440579c7f97235eb2a.webp";